import classNames from 'clsx';
import React from 'react';

import styles from './Panel.scss';

const Panel: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className
}) => <div className={classNames(styles.panel, className)}>{children}</div>;

export default Panel;
